export default defineNuxtPlugin((nuxtApp) => {
  nuxtApp.hook("page:finish", () => {
    document.onkeydown;
    window.addEventListener("keydown", (e) => {
      if (e.altKey && e.key === "d") navigateTo("/");
      if (e.altKey && e.key === "a") navigateTo("/artigos");
      if (e.altKey && e.key === "c") navigateTo("/classificados");
      if (e.altKey && e.key === "b") navigateTo("/banners");
      if (e.altKey && e.key === "v") navigateTo("/videos");
    });
  });
});
